import * as React from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import { alphabeticallySort } from 'modules/core/components/Filters/computeOptions'
import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import teams from 'modules/teams/store/collections/teams'

interface Props {
  field: Field
  label?: string
}

const TeamPicker = ({ label, field }: Props) => {
  const options: SelectOption[] = teams.models
    .slice()
    .sort(alphabeticallySort)
    .map((team) => ({
      value: team.attributes.name,
      label: team.attributes.name,
    }))

  const onChange = (value: string) => {
    field.set(value)
  }

  return (
    <SelectField
      none={i18n.t('custom_reports.especial_filters.employee_team.none')}
      label={label}
      options={options}
      value={field.value}
      onChange={onChange}
    />
  )
}

export default observer(TeamPicker)
